/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for DomaineResource controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_FORMATIONAPI, CLIENT_CONTEXT_TOKEN_FORMATIONAPI } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, DomaineListDTO, DomaineViewDTO } from "../models";

@Injectable({ providedIn: "root" })
export class DomaineResourceService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_FORMATIONAPI);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_FORMATIONAPI;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'formationApi');
    }

    getDomaines(archive?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<DomaineListDTO>>;
    getDomaines(archive?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<DomaineListDTO>>>;
    getDomaines(archive?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<DomaineListDTO>>>;
    getDomaines(archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/domaines`;

        let params = new HttpParams();
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    addDomaine(domaineViewDTO: DomaineViewDTO, observe?: 'body', options?: RequestOptions<'json'>): Observable<DomaineViewDTO>;
    addDomaine(domaineViewDTO: DomaineViewDTO, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<DomaineViewDTO>>;
    addDomaine(domaineViewDTO: DomaineViewDTO, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<DomaineViewDTO>>;
    addDomaine(domaineViewDTO: DomaineViewDTO, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/domaines`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: domaineViewDTO,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateDomaine(domaineViewDTO: DomaineViewDTO, observe?: 'body', options?: RequestOptions<'json'>): Observable<DomaineViewDTO>;
    updateDomaine(domaineViewDTO: DomaineViewDTO, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<DomaineViewDTO>>;
    updateDomaine(domaineViewDTO: DomaineViewDTO, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<DomaineViewDTO>>;
    updateDomaine(domaineViewDTO: DomaineViewDTO, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/domaines`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('put', url, {
            body: domaineViewDTO,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archive(id: number, motif: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<DomaineListDTO>;
    archive(id: number, motif: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<DomaineListDTO>>;
    archive(id: number, motif: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<DomaineListDTO>>;
    archive(id: number, motif: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/domaines/archive/${id}`;

        let params = new HttpParams();
        if (motif != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motif, 'motif');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getDomaineById(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<DomaineViewDTO>;
    getDomaineById(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<DomaineViewDTO>>;
    getDomaineById(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<DomaineViewDTO>>;
    getDomaineById(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/domaines/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
